// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xh_a bhh_a bhh_x","StrollerDetailRating__muted":"xh_b bhh_fm"};